import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebarContainer" }
const _hoisted_2 = { class: "sidebarButton" }
const _hoisted_3 = { class: "yourPoints" }
const _hoisted_4 = { class: "category" }
const _hoisted_5 = { class: "options" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_TE-font-colorB" }, null, -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_gift" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "showSidebar icon-warpit_icon_filter sidebar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sidebar-toggled')))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("rewards.you_have")) + " " + _toDisplayString(_ctx.loyaltyPoints || 0) + " " + _toDisplayString(_ctx.$t("rewards.points")), 1)
    ]),
    _createVNode(_component_Accordion, {
      activeIndex: 0,
      class: "news"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "Izberi katergorijo" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass({
                selected:
                  _ctx.$route.query.type === null || _ctx.$route.query.type === undefined,
              }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCategory(null)))
                }, [
                  _hoisted_6,
                  _createTextVNode(_toDisplayString(_ctx.$t("sidebar_traffic_info.all")), 1)
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localizeCategories, (category, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    class: _normalizeClass(["option", { selected: _ctx.isSelectedCategory(index) }]),
                    onClick: ($event: any) => (_ctx.setCategory(index))
                  }, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(category.name), 1)
                  ], 10, _hoisted_7))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}